import type { Author } from '~/types/blog';

export const getAuthorLink = (author?: Author | null) =>
  author ? `/author/${author.slug}` : '/';
